import script from "./HrWorkforceOrganisationTab.vue?vue&type=script&setup=true&lang=js"
export * from "./HrWorkforceOrganisationTab.vue?vue&type=script&setup=true&lang=js"

import "./common/hrWorkforce.css?vue&type=style&index=0&id=8f30c3ee&scoped=true&lang=css"
import "./HrWorkforceOrganisationTab.vue?vue&type=style&index=1&id=8f30c3ee&scoped=true&lang=css"

import exportComponent from "/Users/amsrafid/Projects/www/miaccounts-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8f30c3ee"]])

export default __exports__